import { RRule } from 'rrule';

export default Object.freeze({
  PAGE_HEADER: 'Upload File',
  ADD_NEW_SOURCE: {
    BUTTON_TEXT: 'Add New Source',
  },
  SOURCE_TABLE: {
    DEFAULTS: {
      STARTING_PAGE: 1,
      PER_PAGE: 10,
      SORT_ORDER: 'asc',
      SORT_BY: 'name',
      PARAMS: {
        page: 1,
        per_page: 10,
        sort_order: 'asc',
        sort_by: 'name',
        type: 2,
      },
    },
    HEADERS: [
      { label: 'Source Identifier', db_key: 'name' },
      { label: 'License Issuer', db_key: 'license_issuer' },
      { label: 'State', db_key: 'state' },
      { label: 'Source', db_key: 'source' },
      { label: 'Category', db_key: 'license_category' },
      { label: 'Frequency', db_key: 'schedule_rule' },
      { label: '' },
    ],
    NO_DATA_TEXT: 'No Records Found',
  },
  CREATE_SOURCE: {
    SOURCE_FORMAT_OPTIONS: [
      { value: 'PDF', label: 'PDF' },
      { value: 'CSV', label: 'CSV' },
      { value: 'XLS', label: 'XLS' },
      { value: 'WEB', label: 'WEB' },
    ],
    FORM_INIT: {
      licenseIssuer: '',
      licenseType: '',
      state: { label: null, value: { code: null, name: null } },
      country: { label: 'US', value: { code: 'US', name: 'United States of America' } },
      sourceFormat: { value: 'PDF', label: 'PDF' },
      sourceModel: null,
      sourceType: 'link',
      approvalType: 0,
      sourceLink: '',
      uploadData: null,
      frequency: '',
      note: '',
      sourceCategory: { value: 1, label: 'Hemp' },
    },
    SOURCE_CATEGORY_OPTIONS: [
      { value: 1, label: 'Hemp' },
      { value: 2, label: 'Cannabis' },
    ],
  },
  EDIT_SOURCE: {
    CHANGE_SOURCE_TYPE_ALERT: {
      TITLE: 'Are you sure you want to replace the existing source?',
      BODY: 'Only the source uploaded to the currently selected source type will be added, and the existing source will be replaced.',
      BUTTONS: {
        CONFIRM: 'Confirm',
        CANCEL: 'Cancel',
      },
    },
  },
  DELETE_SOURCE: {
    ALERT: {
      TITLE: 'Are you sure you want to delete this source?',
      BUTTONS: {
        CONFIRM: 'Confirm',
        CANCEL: 'Cancel',
      },
    },
  },
  FILE_UPLOADER_CONFIGS: {
    PDF: { 'application/pdf': [] },
    CSV: { 'text/csv': [] },
    XLS: {
      'application/vnd.ms-excel': [],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
    },
    WEB: { 'text/html': [] },
  },
  freqOptions: [
    { label: 'Daily', value: RRule.DAILY },
    { label: 'Weekly', value: RRule.WEEKLY },
    { label: 'Monthly', value: RRule.MONTHLY },
    { label: 'Yearly', value: RRule.YEARLY },
  ],
  weekdays: [
    { label: 'Sun', value: RRule.SU },
    { label: 'Mon', value: RRule.MO },
    { label: 'Tue', value: RRule.TU },
    { label: 'Wed', value: RRule.WE },
    { label: 'Thu', value: RRule.TH },
    { label: 'Fri', value: RRule.FR },
    { label: 'Sat', value: RRule.SA },
  ],
  daysInMonth: {
    1: 31,
    2: 28,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31,
  },
  frequencyUnits: {
    [RRule.YEARLY]: 'year(s)',
    [RRule.MONTHLY]: 'month(s)',
    [RRule.WEEKLY]: 'week(s)',
    [RRule.DAILY]: 'day(s)',
  },
  bysetposOptions: [
    { label: 'First', value: '1' },
    { label: 'Second', value: '2' },
    { label: 'Third', value: '3' },
    { label: 'Fourth', value: '4' },
    { label: 'Last', value: '-1' },
  ],
});
